import React from 'react';
import FieldError from './parts/FieldError';
import styled from '@emotion/styled';
import { colors } from '../../../core/styles/theme/default';
import { rem } from 'polished';
import i18n from '../digitID-i18n';

const StyledCheckbox = styled.div`
  display: flex;

  input {
    appearance: none;
    position: relative;
    top: ${rem(4)};
    min-height: 0;
    padding: 0;
    height: ${rem(16)};
    width: ${rem(16)};
    flex-shrink: 0;

    &:checked {
      border: none;
      background: ${colors.purple800}
        url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.6663 4.5L6.66635 12.5L3.33301 9.5' stroke='white' stroke-width='1.5'/%3E%3C/svg%3E%0A")
        no-repeat center / ${rem(17)} ${rem(17)};
    }
  }
`;

const StyledLabel = styled.label`
  margin: 0 0 0 ${rem(10)};
  color: ${colors.black};
  font-size: ${rem(18)};
  line-height: ${rem(26)};

  a {
    font-weight: 500;
    white-space: nowrap;
    text-underline-offset: ${rem(4)};

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

  svg {
    margin-left: ${rem(2)};
    vertical-align: middle;
  }
`;

const Checkbox = ({
  id,
  label,
  locale,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  placeholder,
  isRequired,
  isDisabled,
  errorRenderer,
}: any) => {
  return (
    <div>
      <StyledCheckbox>
        <input
          name={id}
          id={id}
          checked={!!value}
          placeholder={placeholder}
          type="checkbox"
          disabled={!!isDisabled}
          aria-required={!!isRequired}
          data-error={!!error}
          onChange={(e) => {
            if (typeof onChange === 'function') onChange(!!e.target.checked);
          }}
          onFocus={() => {
            if (typeof onFocus === 'function') onFocus();
          }}
          onBlur={() => {
            if (typeof onBlur === 'function') onBlur();
          }}
        />
        {label && (
          <StyledLabel
            htmlFor={id}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </StyledCheckbox>
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <FieldError text={i18n.requiredField[locale]} />
        )
      ) : null}
    </div>
  );
};

export const isValid = (value: any, config: any) =>
  config.isRequired && !value ? false : true;

export default Checkbox;
